import styled from 'styled-components'
const Style = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;

  .badge-container {
    border: 1px solid transparent;
  }
`

export default Style
